import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "news-listing-component" }
const _hoisted_2 = {
  key: 0,
  class: "news-listing-component-no-results"
}
const _hoisted_3 = {
  key: 1,
  class: "news-listing-component-group-results"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "news-listing-component-group-result-title" }
const _hoisted_6 = { class: "news-listing-component-group-result-items" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["href", "target"]
const _hoisted_9 = { class: "news-listing-component-item-summary" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["href", "aria-label"]
const _hoisted_12 = {
  key: 0,
  class: "news-listing-component-group-result-articles"
}
const _hoisted_13 = { class: "news-listing-component-group-articles-heading" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "news-listing-component-group-articles-title" }, " The Day's Articles ", -1 /* HOISTED */)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["href", "target"]
const _hoisted_18 = { class: "news-listing-component-result-item-summary" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["href", "aria-label"]
const _hoisted_21 = {
  key: 2,
  class: "news-listing-component-results"
}
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "news-listing-component-result-item-pretitle" }
const _hoisted_24 = ["href", "target"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["href", "aria-label"]
const _hoisted_27 = {
  key: 3,
  class: "news-listing-component-loading"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 4,
  class: "news-listing-component-buttons"
}
const _hoisted_31 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.status==='ready' && $data.results.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No articles found. "))
      : _createCommentVNode("v-if", true),
    ($props.group && $data.results.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.results, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "news-listing-component-group-result",
              value: result.id
            }, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(result.name), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.items.filter(a => a.sortOrder === 0), (subitem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "news-listing-component-group-result-introduction",
                    value: subitem.id
                  }, [
                    _createElementVNode("a", {
                      class: "news-listing-component-result-item-title",
                      href: subitem.url,
                      target: subitem.target
                    }, _toDisplayString(subitem.name), 9 /* TEXT, PROPS */, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: "news-listing-component-result-item-description",
                        innerHTML: subitem.description
                      }, null, 8 /* PROPS */, _hoisted_10),
                      _createElementVNode("a", {
                        class: "btn btn-secondary",
                        href: subitem.url,
                        "aria-label": `Read Full Introduction: ${subitem.name}`
                      }, " Read Full Introduction ", 8 /* PROPS */, _hoisted_11)
                    ])
                  ], 8 /* PROPS */, _hoisted_7))
                }), 256 /* UNKEYED_FRAGMENT */)),
                (result.items.filter(a => a.sortOrder !== 0).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("button", {
                          class: "news-listing-component-group-articles-button",
                          type: "button",
                          onClick: $event => ($options.toggleGroup(result))
                        }, _toDisplayString(result.expanded ? 'Hide Summaries' : 'Show Summaries'), 9 /* TEXT, PROPS */, _hoisted_15)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(`news-listing-component-result-articles ${result.expanded ? 'news-listing-component-result-articles-expanded' : '' }`)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.items.filter(a => a.sortOrder !== 0), (subitem) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "news-listing-component-result-item",
                            value: subitem.id
                          }, [
                            _createElementVNode("a", {
                              class: "news-listing-component-result-item-title",
                              href: subitem.url,
                              target: subitem.target
                            }, _toDisplayString(subitem.name), 9 /* TEXT, PROPS */, _hoisted_17),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", {
                                class: "news-listing-component-result-item-description",
                                innerHTML: subitem.description
                              }, null, 8 /* PROPS */, _hoisted_19),
                              _createElementVNode("a", {
                                class: "btn btn-secondary",
                                href: subitem.url,
                                "aria-label": `Read Full Article: ${subitem.name}`
                              }, " Read Full Article ", 8 /* PROPS */, _hoisted_20)
                            ])
                          ], 8 /* PROPS */, _hoisted_16))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ], 2 /* CLASS */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 8 /* PROPS */, _hoisted_4))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (!$props.group && $data.results.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.results, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "news-listing-component-result-item",
              value: result.id
            }, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(result.pretitle) + " - " + _toDisplayString(result.date), 1 /* TEXT */),
              _createElementVNode("h2", {
                class: "news-listing-component-result-item-title",
                href: result.url,
                target: result.target
              }, _toDisplayString(result.name), 9 /* TEXT, PROPS */, _hoisted_24),
              _createElementVNode("div", {
                class: "news-listing-component-result-item-description",
                innerHTML: result.description
              }, null, 8 /* PROPS */, _hoisted_25),
              _createElementVNode("a", {
                class: "btn btn-secondary",
                href: result.url,
                "aria-label": `Read Full Article: ${result.name}`
              }, " Read Full Article ", 8 /* PROPS */, _hoisted_26)
            ], 8 /* PROPS */, _hoisted_22))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($data.status==='loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
      : _createCommentVNode("v-if", true),
    ($data.pageNumber < $data.pageCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.nextPage && $options.nextPage(...args))),
            disabled: $data.status==='loading'
          }, "Load More Articles", 8 /* PROPS */, _hoisted_31)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}